import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const oomnitza = defineConnector({
  identifier: "oomnitza",
  name: "Oomnitza",
  tagLine: "IT asset management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://[^/]*\\.oomnitza\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization2", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Generate an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In your Oomnitza console, go to **Configuration > Security > API tokens** and create a new token. Copy it immediately (it is shown only once).",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Subdomain",
          required: true,
          placeholder: "mycompany",
          helperText: "Your Oomnitza domain (e.g. mycompany.oomnitza.com).",
          target: { kind: "configuration", field: "domain" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v3/assets?limit=1`,
  },
  publicEnvVars: ({ domain }) => ({
    OOMNITZA_URL: domain ? `https://${domain}.oomnitza.com` : "",
  }),
});
